export default {
  complete: false,
  id: null,

  // ISO 8601 datetimes, UTC
  createdOn: "2019-01-23T19:00Z",
  createdBy: "ben",
  lastModified: "2019-01-23T19:00Z",
  lastModifiedBy: "ben",
  folder: null,

  // Section 1 - Project Information
  projectName: "Test Project",
  projectID: "001-A",
  city: "Houghton",
  state: "MI",
  owner: "trisight",
  locationDescription: "",
  projectDescription: "",

  // Section 2a - Existing Section
  pavementType: 3, // HMA: 1, Rigid: 2, Composite: 3
  segmentLengthFt: 1500,
  segmentWidthFt: 12,
  intersectionPresent: false,
  twoWayTurnPresent: null, // true, false, null (unknown?)
  // minimumVerticalClearanceRequired: null,

  //Section 2b - Section history
  lastPCRYear: 2014,
  lastPCRReading: 65,
  lastTreatmentYear: 2014,

  // treatmentOptions: [
  //          {text: "Unsure / I don't know", value: 0},
  //          {text: "Overlay (or FDR with Overlay)", value: 1},
  //          {text: "Chip / Cape Seal (or FDR with Chip/Cape Seal)", value: 2},
  //          {text: "New Construction or Full Reconstruction", value: 3}
  //        ]
  lastKnownTreatment: 1, // No response required, otherwise [0, 1, 2, 3]


  // Section 2C - Surface
  hasParkingLanes: false,
  hasParkingLanesDescription: "",
  hasShoulder: false,
  hasShoulderDescription: "",
  hasBikeLane: false,
  hasBikeLaneDescription: "",
  hasCurb: true,
  hasCurbDescription: "",
  hasOtherSurface: false,
  hasOtherSurfaceDescription: "",

  //Section 2D - Subsurface
  hasConcreteLayers: false,
  hasConcreteLayersDescription: "concrete desc",
  hasTreatedBase: true,
  hasTreatedBaseDescription: "treated base desc",
  hasShallowUtilities: false,
  hasShallowUtilitiesDescription: "shallow util desc",
  hasGeotextiles: false,
  hasGeotextilesDescription: "geotext desc",
  hasOtherSubsurface: false,
  hasOtherSubsurfaceDescription: "other desc",

  // Section 3 - Distress Survey
  alligatorCrackingSeverity: 1, // 0, [1, 2, 3]
  alligatorCrackingExtent: 10, // 0-100

  blockCrackingSeverity: 2,
  blockCrackingExtent: 36,

  longitudinalCrackingSeverity: 3,
  transverseCrackingSeverity: 3,
  ruttingSeverity: 1,
  bleedFlushSeverity: 1,
  ravelSeverity: 3,
  patchingSeverity: 2,

  distressNotes: "Unclear if block cracking is longitudinal cracking; currently input as block cracking (M)",


  // Section 4 - Additional Factors
  // chipCapeSealQ1: true,
  // chipCapeSealQ2: true,
  // overlayQ1: true,
  // reconstructionQ1: true,

  isWheelPathFlushing: true,
  requireSmoothMacrotexture: true,
  requireMaintainCurbReveal: true,
  existingSubgradeCbrUnderThreshold: true,


  section4IsValid: false,
};